var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtechImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 416,
    viewBox: "0 0 416 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.667 173.333C346.667 106.427 292.587 52 225.333 52C194.153 51.976 164.159 63.9514 141.57 85.4438C118.98 106.936 105.527 136.297 104 167.44L70.72 211.293C66.56 216.667 70.72 225.333 78 225.333H104V277.333C104 296.573 119.427 312 138.667 312H156V364H277.333V282.707C318.413 263.293 346.667 221.867 346.667 173.333Z",
    fill: "#AE9142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.278 154.981C283.307 157.383 283.308 158.928 283.308 161.673V168.709L297.55 179.862C298.408 180.72 299.094 182.265 298.408 183.98L284.68 208.004C283.822 209.72 281.42 209.72 279.876 209.72L262.888 202.513C259.799 205.601 255.681 207.317 251.734 208.862L248.989 227.394C248.474 228.938 247.616 230.311 245.213 230.311H217.93C216.214 230.311 214.67 228.938 214.67 227.394L212.267 208.862C207.463 207.317 204.202 205.601 200.256 202.341L183.268 209.72C181.723 209.72 180.351 209.72 179.321 208.004L165.593 183.98C164.735 182.265 164.735 180.72 166.451 179.862L180.865 168.709C180.865 166.306 180.351 163.904 180.351 161.673C180.351 159.786 180.865 157.383 180.865 154.981L166.451 143.656C164.735 142.969 164.735 141.253 165.593 138.851L179.321 115.514C180.351 113.97 181.723 113.112 183.268 113.97L200.942 121.177C204.202 117.916 208.32 115.514 212.267 113.97L214.67 96.2955C214.67 93.8931 216.214 93.0352 217.93 93.0352H245.213C247.616 93.0352 248.474 93.8931 248.989 96.2955L251.734 113.97C255.681 115.514 259.799 117.916 262.888 121.177L279.876 113.97C281.42 113.112 283.822 113.97 284.68 115.514L298.408 138.851C299.094 140.567 298.408 142.969 297.55 143.656L282.278 154.981Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 231.978,
    cy: 161.81,
    r: 20.5914,
    fill: "#AE9142"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtechImg);
export default __webpack_public_path__ + "static/media/btech_img.82731e8ccd14ebfc72c0611f38be0069.svg";
export { ForwardRef as ReactComponent };